import {useWallet} from "@alphabatem/vue2-wallet-adapter";
import {parseCustomError} from "@/api/token_swap/errors";
import {baseURI, VALIDATOR_TIP_ACCOUNTS} from "@/api/fluxbeam/constants";
import {web3} from "@project-serum/anchor";
import fetchWithAuth from "@/plugins/fetch";

export default {
	methods: {
		signAndSendTransaction: async function (txn, event, signers = [], onComplete = () => {
		}, store, toastr, alertStore) {
			if(!this.$store) this.$store = store
			if(!this.$toastr) this.$toastr = toastr
			if(!this.$alertStore) this.$alertStore = alertStore

			if (this.$store.state.settings.validatorTip > 0)
				return this.signAndSendBundle(txn, event, signers, onComplete)

			const wallet = useWallet()
			// console.log("signAndSendTransaction:Transaction", txn)

			if (txn.signatures.length === 0) {
				txn.feePayer = wallet.publicKey
				if (!txn.recentBlockhash) {
					const hash = await this.$store.state.solana.client.getLatestBlockhash("confirmed")
					txn.recentBlockhash = hash.blockhash
				}
			}

					try {
			txn = await wallet.signTransaction(txn)

			if (signers.length > 0)
				await txn.partialSign(...signers)

			console.log("Signed TXN", txn)
			const sig = await this._sendSignedTransaction(event, wallet, txn, signers)

			if (!sig) {
				// Transaction failed or was rejected
				return null;
			}

			this.$store.commit("signatures/add_signature", {sig: sig, status: {}})

			onComplete(sig)
			return sig
		} 		catch (error) {
			// Log the original error for debugging
			console.error(`Transaction signing failed: ${event}`, error)
			
			// Use a general error message
			const errorMessage = "Transaction failed";
			
			if(this.$alertStore){
				this.$alertStore.error(`Transaction failed`, errorMessage)
			} else{
				this.$toastr.e(errorMessage, `Transaction failed`)
			}
			window.gtag("event", `${event}_fail`, {error: error})
			
			// Throw with the general error message
			throw new Error(errorMessage);
		}
		},


		signAndSendBundle: async function (_txn, event, signers = [], onComplete = () => {
		}) {
			const wallet = useWallet()
			console.log("signAndSendBundle:Transaction", _txn, this.$store.getters["settings/validatorTip"])
			let txn = _txn //Copy so we can modify later if needed
			const hash = await this.$store.state.solana.client.getLatestBlockhash("confirmed")

			//Create our tip txn
			const feeAccount = VALIDATOR_TIP_ACCOUNTS[Math.floor(Math.random() * VALIDATOR_TIP_ACCOUNTS.length)]

			let tipTxn = new web3.Transaction({
				feePayer: wallet.publicKey,
				recentBlockhash: hash.blockhash
			}).add(
				web3.ComputeBudgetProgram.setComputeUnitLimit({units: 1200}),
				web3.SystemProgram.transfer({fromPubkey: wallet.publicKey, toPubkey: new web3.PublicKey(feeAccount), lamports: this.$store.getters["settings/validatorTip"]})
			)

			if (txn.signatures.length === 0) {
				txn.feePayer = wallet.publicKey
				if (!txn.recentBlockhash) {
					const hash = await this.$store.state.solana.client.getLatestBlockhash("confirmed")
					txn.recentBlockhash = hash.blockhash
				}
			}

			if (signers.length > 0)
				await txn.partialSign(...signers)

			const txns = await wallet.signAllTransactions([txn, tipTxn])
			const encodedTxns = []
			txns.forEach(tx => {
				encodedTxns.push(Buffer.from(tx.serialize()).toString("base64"))
			})

			console.log("SignedBundle", encodedTxns)


			const bundleID = await this._relayBundle(wallet.publicKey, encodedTxns)
			const sig = await this._sendSignedTransaction(event, wallet, txns[0], signers)


			console.log("BundleID", bundleID)
			this.$store.commit("signatures/add_signature", {sig: sig, bundle: bundleID, status: {}})

			setTimeout(() => {
				this._relayBundle(wallet.publicKey, encodedTxns).catch(e => {
					console.error("_relayBundle error", e)
				})
			}, 800)

			onComplete(sig)
			return sig
		},

		signAndSendAllTransactions: async function (txns = [], event, signers = [[]], recentBlockhash, payer, onComplete = () => {
		}, statusCheck = true, client = null) {
			console.log("signAndSendAllTransactions:Transaction", txns)
			const wallet = this.$store.state.wallet.wallet

			//Partial sign if needed
			for (let i = 0; i < txns.length; i++) {
				txns[i].recentBlockhash = recentBlockhash
				txns[i].feePayer = payer
				if (signers[i])
					txns[i].partialSign(...signers[i])
			}

			const sigs = [];
			const signed = await wallet.signAllTransactions(txns)
			for (let i = 0; i < signed.length; i++) {
				const sig = await this._sendSignedTransaction(event, wallet, signed[i], client)

				if (statusCheck)
					this.$store.commit("signatures/add_signature", {sig: sig, status: {}})

				console.log("SIG", sig)
				sigs.push(sig)
			}

			onComplete(sigs)
			return sigs
		},

		_sendSignedTransaction: async function (event, wallet, txn, signers = [], client = null) {
			if(!client)
				client = this.$store.state.solana.client

					const sig = await client.sendRawTransaction(txn.serialize(), {signers: signers, skipPreflight: true}).catch(e => {
			// Log the original error for debugging
			console.error(`sendRawTransaction Transaction Failed ${event}`, e)
			
			// Use a general error message
			const errorMessage = "Transaction failed";
			
			if(this.$alertStore){
				this.$alertStore.error(`Transaction failed`, errorMessage)
			} else{
				this.$toastr.e(errorMessage, `Transaction failed`) //TODO parseCustomError is no good for other programs
			}
			window.gtag("event", `${event}_fail`, {error: e})
			
			// Throw with the general error message
			throw new Error(errorMessage);
		})

		if (!sig) {
			return null;
		}

			//Send via raw client
			client.sendRawTransaction(txn.serialize(), {signers: signers, skipPreflight: true})

			//Relay to our bw market
			this._relayTransaction(wallet.publicKey, Buffer.from(txn.serialize()).toString("base64"), this.$store.state.settings.bandwidthMarkets)

			console.log("SIG", sig)

			if(this.$alertStore){
				this.$alertStore.success("Transaction Sent")
			} else{
				this.$toastr.s({
					title: "Transaction Sent",
					msg: sig,
					onClicked: () => {
						window.open(`${this.$store.state.settings.explorer}/tx/${sig}?${this.$store.getters["settings/clusterQuery"]}`, "_blank")
					}
				})
			}
			window.gtag("event", `${event}_success`, {sig: sig})
			return sig
		},

		_relayTransaction: async function (walletAddr, txn, useBandwidthMarkets = true) {
			fetchWithAuth(`${baseURI}/solana/sendTransaction?bwmkt=${useBandwidthMarkets}`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					wallet: walletAddr,
					transaction: txn
				})
			}).catch(() => {
			})
		},

		_relayBundle: async function (walletAddr, txns) {
			fetchWithAuth(`${baseURI}/solana/sendBundle`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					wallet: walletAddr,
					transactions: txns
				})
			}).catch(() => {
			})
		}
	}
}